<div class="modal-overlay" *ngIf="!reload">
  <div class="lote-guardado" *ngIf="mensaje || icono">
    <i [class]="icono"></i>
    <p>{{ mensaje }}</p>
    <div class="container-buttons container-buttons-no-margin" *ngIf="buttons">
      <button class="btn-lote me-5" (click)="outputDeleteLote('cancelar')">
        Cancelar
      </button>
      <button class="btn-lote ms-5" (click)="outputDeleteLote()">
        Aceptar
      </button>
    </div>
  </div>
  <app-loader *ngIf="!mensaje && !icono" [blanco]="true"></app-loader>
</div>
<div class="modal-overlay" *ngIf="reload">
  <div class="lote-guardado">
    <p>Error con el servidor, favor de recargar la página</p>
    <i class="bi bi-arrow-counterclockwise" (click)="reloadApp()"></i>
  </div>
</div>
